import React, { useState } from 'react';
import { StyledSubRollingOffer } from './style';
import { SubRollingOfferProps } from 'templates/RollingOffer/shared/types';
import { EBadgePosition, ESubRollingOfferCollectMode } from 'utils/enums';
import { SubRollingOfferPrice } from './components/Price';
import { SubRollingOfferProducts } from './components/Products';
import { EBadgeDesignType } from 'components/Badge/types';
import { DefaultSaleBadge } from 'components/Badge/Sale/DefaultSaleBadge';
import { generateSalePercentageBasedOnType } from 'utils/index';
import { Box } from '@mui/material';

interface ISubRollingOfferProps extends SubRollingOfferProps {
  isAnimating: boolean;
  isPreview: boolean;
  isHorizontalViewEnabled: boolean;
}

export const MatchMastersSubRollingOffer: React.FC<ISubRollingOfferProps> = ({
  isAnimating,
  index,
  backgroundColor = { colorOne: '#CACBD4' },
  backgroundImage,
  lockImage = 'https://media-dev.appcharge.com/media/66be029440fd9d64e8b421a9/1732101369729__f5611ed5-cb85-4b81-b8f1-373921b64d86',
  buttonColor,
  collectText = 'FREE',
  buttonTextColor = '#ffffff',
  collectMode,
  selectOffer,
  prices,
  products,
  isPreview,
  productSale,
  isHorizontalViewEnabled,
}) => {
  const [isAnimatingPrice, setIsAnimatingPrice] = useState<boolean>(false);

  const isSelectable =
    collectMode === ESubRollingOfferCollectMode.AVAILABLE &&
    !isAnimating &&
    !isAnimatingPrice;

  return (
    <StyledSubRollingOffer
      className={'sub-offer'}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      buttonColor={buttonColor}
      buttonTextColor={buttonTextColor}
      lockImage={lockImage}
      clickable={isSelectable}
      onClick={isSelectable && !isPreview ? selectOffer : undefined}
      isHorizontalViewEnabled={isHorizontalViewEnabled}
    >
      {productSale && productSale?.sale > 0 && (
        <Box className="badge-wrapper">
          <DefaultSaleBadge
            salePercentage={productSale.sale}
            position={EBadgePosition.TOP}
            text={`${generateSalePercentageBasedOnType(
              productSale.sale,
              productSale.type,
            )} MORE`}
            designType={EBadgeDesignType.MIDDLE}
            salePercentageDisplayType={productSale.type}
            isTextAutoResized={false}
          />
        </Box>
      )}
      <SubRollingOfferProducts
        products={products}
        index={index}
        salePercentage={productSale?.sale || 0}
        isHorizontalViewActive={isHorizontalViewEnabled}
      />
      <SubRollingOfferPrice
        index={index}
        prices={prices}
        buttonText={collectText}
        setIsAnimatingPrice={setIsAnimatingPrice}
        lockImage={
          collectMode === ESubRollingOfferCollectMode.LOCKED ? lockImage : ''
        }
        isHorizontalViewActive={isHorizontalViewEnabled}
      />
    </StyledSubRollingOffer>
  );
};
